import { object } from 'prop-types';
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ResponsiveContainer, reportPrimaryColor, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Label } from 'recharts';
import date from '../../workflow/validations/date';
import LineChartTemplate2 from './LineChartTemplate2';

export default class LINECHART extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allSeries: this.props.graphData ? this.props.graphData[0].tableData : [],
      xAxisData: [],
    }
  }


  render() {
    const { graphData, colors, legendName, reportPrimaryColor, xLabel, yLabel, graphHeight, series, isDashsedLineChart, allowAddition, generatedActionCodeForAllowAddition, inlineActions, triggerAction, workflow, triggerData, companyDetails } = this.props;

    const { allSeries, xAxisData } = this.state
    const reportLibraryTemplate = companyDetails && companyDetails.companySettings && companyDetails.companySettings.reportLibraryTemplate ? companyDetails.companySettings.reportLibraryTemplate : "TEMPLATE_ONE"
   

    const newOptions = {
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: [2],
        curve: 'straight',
        // dashArray: [0, 8, 5]
      },
      title: {
        // text: 'Page Statistics',
        align: 'left'
      },
      legend: {
        tooltipHoverFormatter: function (val, opts) {
          return val + ' - <strong>' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '</strong>'
        }
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 6
        }
      },
      xaxis: {
        categories: []
        ,
      },
      tooltip: {
        y: [
          {
            title: {
              formatter: function (val) {
                return val + " : "
              }
            }
          },
          {
            title: {
              formatter: function (val) {
                return val + " : "
              }
            }
          },
          {
            title: {
              formatter: function (val) {
                return val + " : ";
              }
            }
          }
        ]
      },
      grid: {
        borderColor: '#f1f1f1',
      }
    }

    const allStoredKey = []
    if (allSeries) {
      Object.entries(allSeries).map(([key, value]) => {
        if (key !== "Month") {
          allStoredKey.push({
            name: key,
            data: []
          })
        }

      })
    }
    if (this.props.graphData) {
      this.props.graphData.map((graph, index) => {
        // Object.entries(allStoredKey).map(([key, value]) => {
        //   allStoredKey[key].data.push(graph.tableData[value.name])
        // })
        allStoredKey.map((key, index) => {
          allStoredKey[index].data.push(graph.tableData[key.name])
        })
        if (graph && graph.tableData) {
          xAxisData.push(graph.tableData["Month"])
        }
      })
    }
    newOptions.xaxis.categories = xAxisData

    return (
      <div style={{ width: '100%' }} >
        {
          reportLibraryTemplate === "TEMPLATE_ONE" &&
        <div style={{ width: '100%' }}

          className='reportMainContainer'>
          {
            isDashsedLineChart ?
              <div>
                <div id="chart">
                  <ReactApexChart options={newOptions} series={allStoredKey} type="line" height={350} />
                </div>
                <div id="html-dist"></div>
              </div>
              :
              <ResponsiveContainer height={graphHeight}>
                <LineChart data={graphData} margin={{ top: 0, right: 10, left: 10, bottom: 20 }}>
                  <XAxis dataKey="xProperties">
                    <Label value={xLabel} offset={0} position="bottom" />
                  </XAxis>
                  <YAxis label={{ value: yLabel, angle: -90, position: 'inside', offset: -15, dx: 40, }} />
                  <CartesianGrid strokeDasharray="3 3" />
                  <Tooltip />
                  {
                    series ?
                      series.map((y, index) => {
                        return <Line name={y.legendName} type='monotone' dataKey={y.yPropertyName} stroke={colors[index]} fill={colors[index]} />
                      }) :
                      <Line name={legendName} type='monotone' dataKey='yProperties' stroke={reportPrimaryColor ? reportPrimaryColor : '#8884d8'} fill={reportPrimaryColor ? reportPrimaryColor : '#8884d8'} />
                  }
                  <Legend verticalAlign="top" height={36} />
                </LineChart>
              </ResponsiveContainer>
          }

        </div>
        } 
        {
          reportLibraryTemplate === "TEMPLATE_TWO" &&
        <LineChartTemplate2 {...this.props} />
       } 

      </div>




    );
  }
}
